import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll'
import { NavLink } from 'react-router-dom'
import Logo from '../../images/site_logo/site_logo_1.svg'
import MobileMenu from '../MobileMenu/MobileMenu'

const Header = (props) => {

    const [mobailActive, setMobailState] = useState(false);

    const [isSticky, setSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80) {
                setSticky(true);
            } else {
                setSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <header className={`site_header  ${isSticky ? 'sticky' : ''}`}>
        </header>

    )
}

export default Header;